import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChainMaintenanceComponent } from './chain-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: ChainMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChainMaintenanceRoutingModule { }
